import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  NuvemEnvioCreateDispatchesResponseDto,
  NuvemEnvioCreateDispatchesRequestDto,
} from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import {
  getNuvemEnvioLabelsData,
  getNuvemEnvioLabelsStatus,
} from '../../ordersSlice/ordersSelectors';
import {
  createNuvemEnvioLabels as createNuvemEnvioLabelsAction,
  resetNuvemEnvioLabels as resetNuvemEnvioLabelsAction,
} from '../../ordersSlice/ordersSlice';

export interface UseCreateNuvemEnvioLabelsResult {
  createNuvemEnvioLabels: (
    labels: NuvemEnvioCreateDispatchesRequestDto,
  ) => Promise<NuvemEnvioCreateDispatchesResponseDto>;
  resetNuvemEnvioLabels: () => void;
  data: NuvemEnvioCreateDispatchesResponseDto;
  status: {
    isIdle: boolean;
    isLoading: boolean;
    isError: boolean;
    isSuccess: boolean;
  };
}

function useCreateNuvemEnvioLabels(): UseCreateNuvemEnvioLabelsResult {
  const dispatch = useAppDispatch();

  const data = useSelector(getNuvemEnvioLabelsData);
  const status = useSelector(getNuvemEnvioLabelsStatus);

  const createNuvemEnvioLabels = useCallback(
    async (
      labels: NuvemEnvioCreateDispatchesRequestDto,
    ): Promise<NuvemEnvioCreateDispatchesResponseDto> => {
      const response = await dispatch(
        createNuvemEnvioLabelsAction({
          createFile: labels.createFile,
          fulfillmentOrderIds: labels.fulfillmentOrderIds,
        }),
      ).unwrap();

      return response;
    },
    [dispatch],
  );

  const resetNuvemEnvioLabels = useCallback(() => {
    dispatch(resetNuvemEnvioLabelsAction());
  }, [dispatch]);

  return {
    createNuvemEnvioLabels,
    resetNuvemEnvioLabels,
    data,
    status,
  };
}

export default useCreateNuvemEnvioLabels;
